const styles = theme => ({
  root: { height: 90 },
  flexContainer: { height: 90 },
});

export default styles;



// WEBPACK FOOTER //
// ./src/containers/routeTabs/RouteSideTabsStyles.js